import Avatar from '../ui/Avatar';

/**
 * Header da configuração do agente: avatar, nome público, role/tag e botão Salvar.
 * "Salvar alterações" é mock (feedback visual apenas); persistência real via updateAgent no container.
 *
 * @param {Object} props
 * @param {{ publicName: string, internalName?: string, teamId?: string }} props.agent
 * @param {Record<string, { name: string }>} [props.teamsMap]
 * @param {() => void} props.onSave - chamado ao clicar em Salvar (mock: pode mostrar toast/sucesso)
 */
export default function AgentHeader({ agent, teamsMap = {}, onSave }) {
  const roleLabel = agent.teamId
    ? teamsMap[agent.teamId?.toUpperCase()]?.name || agent.teamId
    : '—';

  return (
    <div className="flex items-center justify-between bg-appSurface p-6 rounded-3xl border border-appSurfaceBorder shadow-sm flex-wrap gap-4">
      <div className="flex items-center gap-6">
        <Avatar
          label={agent.publicName || agent.internalName}
          size="xl"
          color="bg-appPrimaryLight text-appPrimaryText"
        />
        <div>
          <h2 className="text-2xl font-bold text-appText">{agent.publicName || agent.internalName}</h2>
          <p className="text-appTextMuted text-sm">{agent.internalName}</p>
          {roleLabel !== '—' && (
            <p className="text-appTextMuted text-xs mt-1">{roleLabel}</p>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={onSave}
        className="px-6 py-2.5 bg-appPrimary text-white rounded-xl font-bold text-sm hover:opacity-90 transition-all shadow-lg"
      >
        Salvar Alterações
      </button>
    </div>
  );
}
